export default {
  configs: {
    menus: [
      {
        icon: 'mdi-cash-register',
        style: 'colTeal',
        name: 'POS分析',
        model: false,
        children: [
          { code: 'IF00010', number: 1 },
          { code: 'IF00011', number: 2 },
          { code: 'IF00019', number: 3 },
          { code: 'IF00020', number: 4 },
          { code: 'IF00012', number: 5 },
          { code: 'IF00013', number: 6 },
          { code: 'IF00021', number: 7 },
          { code: 'IF00009', number: 8 },
          { code: 'IF00017', number: 9 },
          { code: 'IF00018', number: 10 }
        ]
      },
      {
        icon: 'mdi-cellphone-text',
        style: 'colDeepOrange',
        name: 'ID-POS分析',
        model: false,
        children: [
          { code: 'IF00008', number: 1 },
          { code: 'IF00022', number: 2 },
          { code: 'IF00027', number: 3 },
          { code: 'IF00028', number: 4 },
          { code: 'IF00005', number: 5 },
          { code: 'IF00002', number: 6 },
          { code: 'IF00025', number: 7 },
          { code: 'IF00003', number: 8 },
          { code: 'IF00004', number: 9 },
          { code: 'IF00023', number: 10 },
          { code: 'IF00006', number: 11 },
          { code: 'IF00007', number: 12 },
          { code: 'IF00016', number: 13 },
          { code: 'IF00030', number: 14 }
        ]
      },
      {
        icon: 'mdi-table-search',
        style: 'colAmber',
        name: '実績抽出',
        model: false,
        children: [
          { code: 'IF00001', number: 1 }
        ]
      },
      {
        icon: 'mdi-file-download-outline',
        style: 'colLightGreen iconPng',
        name: '全国比較',
        model: false,
        children: [
          { code: 'IF00024', number: 1 },
          { code: 'IF00029', number: 2 },
          { code: 'IF00026', number: 3 }
        ]
      },
      {
        icon: 'mdi-file-download-outline',
        style: 'colDeepPurple',
        name: '各種ダウンロード',
        model: false,
        children: [
          { code: 'IF00014', number: 1 },
          { code: 'IF00015', number: 2 }
        ]
      },
      {
        icon: 'mdi-account-group',
        style: 'colPink',
        name: 'グループ管理',
        model: false,
        children: [
          { code: 'GR00001', number: 1 },
          { code: 'GR00003', number: 2 },
          { code: 'GR00005', number: 3 },
          { code: 'GR00007', number: 4 }
        ]
      },
      {
        icon: 'mdi-settings-outline',
        style: 'colGray',
        name: '管理機能',
        model: false,
        children: [
          { code: 'AD00001', number: 1 },
          { code: 'AD00002', number: 2 },
          { code: 'AD00003', number: 3 },
          { code: 'AD00004', number: 3 },
          { code: 'AD00005', number: 5 },
          { code: 'AD00008', number: 4 },
          { code: 'AD00009', number: 7 },
          { code: 'AD00011', number: 5 },
          { code: 'AD00012', number: 9 }
        ]
      }
      // { icon: 'mdi-content_copy', name: 'MapScan', name: 'PageMapScan' }
    ]
  }
}
